module.exports = __webpack_public_path__ + "img/bg-1200.3c3fe1fc.jpg";